import type { ArdoqId } from '@ardoq/api-types';
import type { ItemSet } from 'tabview/visualizations/aq-blocks/types';

/**
 * The component a double-click navigates to, or null. `buildGroupNode` gives a
 * group its component's `modelId` while leaving `isComponent` false, and a
 * double-click on group padding hovers the group itself — so the flag, not the
 * id, is what stops a group header navigating. References take priority over
 * nodes when hovering, so an activated reference has no node at all.
 */
export const activatedComponentId = (items: ItemSet): ArdoqId | null => {
  const node = items.node();
  if (!node?.isComponent) return null;
  return node.modelId;
};
